import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

export const WrapperTimePicker = ({ filters: value, handleFilterChange, type = 'startTime', inputProps }) => {
    const getLabel = () => {
        if (!value) return 'HH:mm';
        return type === 'startTime' ? 'Hora desde' : 'Hora hasta';
    };

    return (
        <TimePicker
            label={getLabel()}
            value={value ? dayjs(value, 'HH:mm') : null}
            onChange={(newValue) => {
                handleFilterChange({
                    target: {
                        name: type,
                        value: newValue ? newValue.format('HH:mm') : ''
                    }
                });
            }}
            format="HH:mm"
            ampm={false}
            slotProps={{
                textField: {
                    ...inputProps,
                    sx: {
                        '& .MuiInputBase-root': {
                            height: '40px'
                        },
                        ...inputProps?.sx
                    }
                }
            }}
        />
    );
};

export default WrapperTimePicker; 